import {TakipAcStatusEnum} from "./parser/TakipAcStatusEnum";
import app from "@/main";
import {MtsXmlParser} from "./MtsXmlParser";
import TakipAcInjectable from "./TakipAcInjectable";
import {Mixins} from "./Mixins";
import {MtsTakipTalebiOlusturCevap, MtsTakipTalebiOlusturTalep} from "../uyap/MtsTakipTalebiOlustur";
import {MtsDavaAcilisTalep} from "../uyap/MtsDavaAcilis";
import {saveAs} from "file-saver";
import {TamamlanmayanDosyalarRow} from "../uyap/TamamlanmayanDosyalar";
import Args from "@/plugins/uyap-plugin/takip_ac/parser/Args";
import {OdemeTipiEnum} from "@/plugins/uyap-plugin/takip_ac/OdemeTipleri";
import {DosyaEvraklarCevap, IDosyaEvrak} from "@/plugins/uyap-plugin/uyap/DosyaEvraklar";

export default class MtsTakipAc extends TakipAcInjectable {
    parsedFile!: MtsXmlParser;
    tevziBilgileri !: MtsTakipTalebiOlusturCevap;
    tempId: number = 0;
    toplamTakibeEsasMiktar: number = 1;
    mtsHarcBilgileri = {
        selectedTarafHashKeyList: ["kurum_0"],
        selectedTarafHashList: []
    }
    dosyaBilgileri!: TamamlanmayanDosyalarRow;
    evraklar!: DosyaEvraklarCevap;

    static fromJson(jsonData: any): MtsTakipAc {
        let mtsTakipAc =  Args.staticFromJson(jsonData,new MtsTakipAc());
        mtsTakipAc.parsedFile = MtsXmlParser.fromJson(jsonData.parsedFile);
        return mtsTakipAc;
    }

    //Yetkili Kurum secmesi gerekiyor.

    async runQuery(): Promise<void> {
        try {
            this.setStatus(TakipAcStatusEnum.QUERY_PENDING);
            for (const taraf of this.parsedFile.tarafList) {
                try {
                    console.log("MTS TARAF", taraf);
                    console.log("MTS parsedFile.formData", this.parsedFile);
                    await taraf.runQuery(this.parsedFile.formData.alacakliTaraf);
                } catch (e) {
                    this.setStatus(TakipAcStatusEnum.QUERY_FAIL);
                    console.log("tarafList HATA", e);
                }
            }
            await this.runQueryForHarcList();
            this.setStatus(TakipAcStatusEnum.QUERY_SUCCESS);
            return Promise.resolve();
        } catch (e) {
            this.setStatus(TakipAcStatusEnum.QUERY_FAIL);
            console.log("ERR RUNQUERY");
            console.log(e);
            return Promise.reject(e);
        }
    }

    async runQueryForHarcList(): Promise<any> {
        try {
            let harcBilgileri = await app.$uyap.MtsHarcList().run(this.toUyapJson());
            this.parsedFile.harcMasrafToplam = harcBilgileri.toplam;
            // @ts-ignore
            this.mtsHarcBilgileri.selectedTarafHashList = harcBilgileri.data;
            return Promise.resolve();
        } catch (e) {
            return Promise.reject(e);
        }
    }

    async tevziAl(): Promise<any> {
        try {
            this.setStatus(TakipAcStatusEnum.PREPARE_PROCESSING);
            await this.mukerrerDosyaKontrol(this.parsedFile.hash, "xml");
            this.addMessage('info', 'Tevzi alınıyor!')
            this.tevziBilgileri = await app.$uyap.MtsTakipTalebiOlustur().run(this.tevziToUyapJson());
            this.addMessage('info', 'Tevzi alındı.!');
            this.addMessage('success', 'Tevzi alma işlemi başarılı!');
            this.setStatus(TakipAcStatusEnum.PREPARE_SUCCESS);
            await this.tevziAlinmisDosyaKaydet();
            try{
                this.addMessage('info', 'Takip talebi hazırlanıyor!');
                await this.mtsGetImzasizUdfFromUyap(this.tevziBilgileri.dosyaId);
            }catch (e) {

                console.log("TAKIP TALEBI INDIRILEMEDI")
                console.log("error",e);

            }
            return Promise.resolve();
        } catch (e) {
            this.setStatus(TakipAcStatusEnum.PREPARE_FAILED);
            this.addMessage('error', 'Tevzi alma işleminde hata oluştu!' + e.message);
            return Promise.reject(e);
        }
    }

    async tevziAlinmisDosyaKaydet(): Promise<any> {
        ///v1/uyap-takip
        let uyap_id =
            this.tevziBilgileri.birimID +
            "/" +
            this.convertToISOFormat(this.tevziBilgileri.dosyaAcilisTarihi);
        return await app.$http.post("/api/v1/uyap-takip/", {
            hash: this.parsedFile.hash,
            type: "xml",
            dosya: this,
            uyap_dosya_id: this.tevziBilgileri.dosyaId,
            uyap_id: uyap_id,
            uyap_id_hash: btoa(uyap_id),
            vekalet_id: this.parsedFile.vekaletObject?.id,
            dayanak: this.parsedFile.dayanaklar,
            status: 1,
        });
    }

    async takipTalebiIndir() {
        saveAs(this.imzasizUdf, "takiptalebi.udf");

    }

    async hemenTakipAc(): Promise<void>{
        await this.runQuery();
        await this.tevziAl();
        await this.takipBaslat(false);
    }

    async takipBaslat(isTamamlanmayanDosya = true): Promise<void> {
        try {

            this.setStatus(TakipAcStatusEnum.OPEN_PROCESSING);
            await this.vekaletKontrol();
            await this.dayanakKontrol();
            if(isTamamlanmayanDosya){
                let uyapDosya = await app.$uyap.TamamlanmayanDosyaBul().run({
                    birimId: this.tevziBilgileri.birimID,
                    acilisTime: new Date(this.tevziBilgileri.dosyaAcilisTarihi).getTime(),
                    dosyaAcilisTarihi: this.tevziBilgileri.dosyaAcilisTarihi
                },true);
                //let dosyaId = uyapDosya.dosyaID;
                this.tevziBilgileri.dosyaId = uyapDosya.dosyaID;
            }

            await this.mtsGetImzasizUdfFromUyap(this.tevziBilgileri.dosyaId);
            //await this.mukerrerDosyaKontrol();
            await this.mukerrerDosyaKontrolFromTakipTalebi();
            await this.takipAcilisEvraklariniGonder(this.tevziBilgileri.dosyaId,true);

            if (this.toplamTakibeEsasMiktar == 0 && this.parsedFile.formData.odemeYapilmasin === true) {
                //harc muafli takip acilmissa odeme yapmiyor...
                await this.setTakipBilgileriFromTakipAcilisEvraklariResponse();
            } else if (this.toplamTakibeEsasMiktar == 0) {
                //harc muafli takip acilmissa odeme yapmiyor...
                await this.setTakipBilgileriFromTakipAcilisEvraklariResponse();
            } else if (this.parsedFile.formData.odemeYapilmasin === true) {
                this.takipBilgileri.dosyaEsasNo = "Dosya tevzi alındı. " + this.takipAcilisEvraklariResponse.message;
                this.takipBilgileri.icraDairesi = "Merkezi Takip Sistemi";
                this.addMessage("success", "Takibiniz ödeme yapılmasın seçilerek açılmıştır. Ödemenizi UYAP üzerinden yapabilirsiniz.");
                this.setStatus(TakipAcStatusEnum.OPEN_SUCCESS);
            } else {
                await this.odemeYap();
            }
            return this.setTakipBilgileriToIcraPro(this.parsedFile.mtsDosyaBilgileri);
        } catch (e) {
            this.addMessage('error', 'HATA - ' + e.message);
            this.setStatus(TakipAcStatusEnum.OPEN_FAIL);
        }
    }

    async takipBaslatYeni(isHemenAc: boolean = false, odemeYapilsin: boolean = false): Promise<void> {
        try {
            this.setStatus(TakipAcStatusEnum.OPEN_PROCESSING);

            await this.tevziAl();

            await this.vekaletKontrol(isHemenAc);
            await this.dayanakKontrol(isHemenAc);

            if (!isHemenAc)
                await this.mtsGetImzasizUdfFromUyap(this.tevziBilgileri.dosyaId);

            // TODO: SORULACAK: toplamTakibeEsasMiktar sıfır ise otomatik açar ödeme yapılmasın ise göndermesin
            await this.takipAcilisEvraklariniGonder(this.tevziBilgileri.dosyaId, true);

            if (this.toplamTakibeEsasMiktar == 0) {
                //harc muafli takip acilmissa odeme yapmiyor...
                await this.setTakipBilgileriFromTakipAcilisEvraklariResponse();
            } else if (!odemeYapilsin) {
                this.takipBilgileri.dosyaEsasNo = "Dosya tevzi alındı. " + this.takipAcilisEvraklariResponse.message;
                this.takipBilgileri.icraDairesi = "Merkezi Takip Sistemi";
                this.addMessage("success", "Takibiniz ödeme yapılmasın seçilerek açılmıştır. Ödemenizi UYAP üzerinden yapabilirsiniz.");
                this.setStatus(TakipAcStatusEnum.OPEN_SUCCESS);
            } else {
                await this.odemeYap();
            }
            return this.setTakipBilgileriToIcraPro(this.parsedFile.mtsDosyaBilgileri);
        } catch (e) {
            this.addMessage('error', 'HATA - ' + e.message);
            this.setStatus(TakipAcStatusEnum.OPEN_FAIL);
            throw new Error(e.message);
        }
    }

    async odemeYap(): Promise<void> {
        try {

            //https://avukatbeta.uyap.gov.tr/mtHarcListDosyaid_brd.ajx POST params dosyaId json olarak
            //[{"harcmasrafKodStr":144205,"harcmasrafBedelmiOranmi":"O","harcMasrafOran":2,"hesapMiktar":6291.35,"ekranID":9,"pesinHarcDusulsunmu":"H","harcMasrafAltSiniri":615.4,"hmDurumu":0,"hmAktif":false,"isSatirDegisecek":false,"harcMasrafKod":63266,"harcMasrafAdi":"MTS Harcı","aciklama":"Mts Harcı","baslangicHarci":"E","harcMasraf":"H","harcTip":34,"gv_tabi":0,"dv_tabi":0,"yg_tabi":0,"makbuzTipi":1},{"harcmasrafKodStr":144200,"harcmasrafBedelmiOranmi":"B","harcMasrafBedel":87.5,"hesapMiktar":87.5,"ekranID":9,"pesinHarcDusulsunmu":"H","hmDurumu":0,"hmAktif":false,"isSatirDegisecek":false,"harcMasrafKod":12809,"harcMasrafAdi":"Vekalet Suret Harcı","aciklama":"Vekaletname Suret Harcıdır","baslangicHarci":"E","harcMasraf":"H","harcTip":14,"gv_tabi":0,"dv_tabi":0,"yg_tabi":0,"makbuzTipi":1}]
            //https://avukatbeta.uyap.gov.tr/vekaletPuluBedeli.ajx POST json return düz 138

            await app.$uyap.MtsHarcListDosyaId().run({dosyaId: this.tevziBilgileri.dosyaId});
            await app.$uyap.VekaletPuluBedeli().run({});
            let takipBilgileri = await app.$uyap.MtsDavaAcilis().run({dosyaId: this.tevziBilgileri.dosyaId,odemeTipi:OdemeTipiEnum.Ebarobirlikkart});
            this.takipBilgileri.dosyaEsasNo = takipBilgileri.dosyaNo;
            this.takipBilgileri.icraDairesi = takipBilgileri.birimAdi;
            this.addMessage('success', 'Takip açıldı.');
            this.setStatus(TakipAcStatusEnum.OPEN_SUCCESS);
        } catch (e) {
            this.addMessage('error', 'Ödeme hatası - ' + e.message);
            throw new Error(e.message);
        }
    }

    async vekaletKontrol(isHemenTakipBaslat: boolean = false): Promise<void> {
        try {
            if (isHemenTakipBaslat) {
                // @ts-ignore
                this.vekalet = Mixins.b64toBlob(this.parsedFile.vekalet.data, this.parsedFile.vekalet.mimeType)
                return ;
            }
            if (!this.getVekaletBlob() || this.getVekaletBlob() == null) {
                if (this.parsedFile.vekaletObject) {
                    this.vekalet = await app.$uyapHelper.getBlobFromLink(
                        "/api/v1/file/download/" +
                        this.parsedFile.vekaletObject.file_path.replace("uploads/", "")
                    );
                } else {
                    let message = "Vekalet eklenmemiş lütfen vekalet ekleyiniz!";
                    this.addMessage("error", message);
                    throw  new Error(message);
                }
            }
        } catch (e) {
            this.addMessage("error", e.message);
            throw new Error(e);
        }
    }

    async dayanakKontrol(isHemenTakipBaslat: boolean = false): Promise<void> {
        try{
            if (isHemenTakipBaslat) {
                for (const dayanak of this.parsedFile.dayanaklar) {
                    // @ts-ignore
                    let dayanakBlob = Mixins.b64toBlob(dayanak.data,dayanak.mimeType);
                    this.dayanaklar.push(dayanakBlob);
                }
                return;
            }
            for (const dayanak of this.parsedFile.dayanaklarObject) {
                let blob = await app.$uyapHelper.getBlobFromLink(
                    "/api/v1/file/download/" + dayanak.file_path.replace("uploads/", "")
                );
                this.dayanaklar.push(blob);
            }
        }catch (e) {
            throw new Error("Dayanaklar yüklenemedi !. " + e.message);
        }
    }

    davaAcilisToUyapJson(): MtsDavaAcilisTalep {
        let data: any = this.tevziToUyapJson();
        data.dosyaId = this.tevziBilgileri.dosyaId;
        return data;
    }

    tevziToUyapJson(): MtsTakipTalebiOlusturTalep {
        let {
            dosyaAciklama_48_4,
            mahiyetList,
            dosyaKriterList,
            terekemi,
            selectedIl,
            selectedBirim
        }: any = this.parsedFile.mtsDosyaBilgileri;
        let tarafList = this.toUyapTarafList();
        terekemi = Mixins.booleanToXmlStrings(terekemi);

        return {
            MTS: 1,
            MTSDosyaBilgileri: JSON.stringify({
                dosyaAciklama_48_4,
                mahiyetList,
                dosyaKriterList,
                terekemi,
                selectedIl,
                selectedBirim,
            }),
            tarafList: JSON.stringify(tarafList),
            ilamsizList: JSON.stringify(this.parsedFile.ilamsizList.map((i) => i.toUyapJson())),
            MTSHarcBilgileri: JSON.stringify(this.mtsHarcBilgileri)
        }
    }

    toUyapTarafList() {
        //let tarafList = this.tarafList.map((i) => i.toUyapJson());
        let kisiList = this.parsedFile.tarafList.filter(taraf => taraf.isKisi() === true);
        let kurumList = this.parsedFile.tarafList.filter(taraf => taraf.isKurum() === true);
        return {
            kisiList: kisiList.map((taraf, key) => taraf.toUyapJson(key)),
            kurumList: kurumList.map((taraf, key) => taraf.toUyapJson(key))
        };
    }

    toUyapJson() {
        let result = {
            ilamsizList: JSON.stringify(this.parsedFile.ilamsizList.map((i) => i.toUyapJson())),
            tarafList: JSON.stringify(this.toUyapTarafList())
        };
        console.log(result);
        console.log("MTS toUyapJson");
        return result;
    }

    toUyapJsonTest() {
        return {
            ilamsizList: this.parsedFile.ilamsizList.map((i) => i.toUyapJson()),
            tarafList: this.toUyapTarafList()
        };
    }

    async getTahsilHarciMakbuzuBlob(): Promise<Blob> {
        return await this.getEvrakBlobFromType(
            "Tahsil Harcı Makbuzu(Sayman Mutemet Alındısı)"
        );
    }

    async getTahsilatMakbuzuBlob(): Promise<Blob> {
        return await this.getEvrakBlobFromType("Tahsilat makbuzu");
    }

    async getDosyaEvraklar() {
        if (!this.evraklar)
            this.evraklar = await app.$uyap.DosyaEvraklar().run({dosyaId: this.tevziBilgileri.dosyaId});
    }

    async getEvrakBlobFromType(type: string): Promise<Blob> {
        await this.getDosyaEvraklar();

        const tumEvraklarList = Object.values(this.evraklar?.tumEvraklar || {}).reduce(
            (acc: IDosyaEvrak[], list) => acc.concat(list),
            []
        );

        const evrak = tumEvraklarList.find((item: IDosyaEvrak) => item.tur && item.tur.includes(type));

        if (evrak) {
            let dosyaId = evrak.dosyaId || this.tevziBilgileri?.dosyaId;
            let evrakId = evrak.evrakId || evrak.ggEvrakId;

            if (!dosyaId || !evrakId) {
                throw new Error("Evrak bilgileri eksik.");
            }

            return await app.$uyap.EvrakIndir().run({
                dosyaId: String(dosyaId),
                evrakId: String(evrakId),
                yargiTuru: "",
            });
        } else {
            throw new Error(`${type} evrağı bulunamadı.`);
        }
    }
}